import { Callback, Step } from 'react-joyride'
import { Dispatch } from '~/store/types'
import { ActionTypes, BeginTourParam, TOUR_ACTIONS } from './types'

const setCallback = (callback: Callback | undefined) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: TOUR_ACTIONS.SET_CALLBACK,
    callback,
  })
}

const setIsTourRunning = (isTourRunning: boolean) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: TOUR_ACTIONS.SET_IS_TOUR_RUNNING,
    isTourRunning,
  })
}

const setSteps = (steps: Step[]) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: TOUR_ACTIONS.SET_STEPS,
    steps,
  })
}

export const endTour = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch(setCallback(undefined))
  dispatch(setIsTourRunning(false))
  dispatch(setSteps([]))
}

export const beginTour = (param: BeginTourParam) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch(setCallback(param.callback))
  dispatch(setIsTourRunning(true))
  dispatch(setSteps(param.steps))
}
